import React from 'react';
import { MButtonOverlay } from '../MButtonOverlay/index';
import * as Styled from './MVideoThumbnail.styles';
import type { MVideoThumbnailProps } from './MVideoThumbnail.types';

export const MVideoThumbnail: React.FC<MVideoThumbnailProps> = ({ mButtonOverlay, className, ...rest }) => {
  return (
    <Styled.Wrapper
      className={className}
      data-component-name="m-web-ui-kit-MVideoThumbnail"
      data-testid="web-ui-kit-MVideoThumbnail"
      {...rest}
    >
      <Styled.OverlayContainer>
        <MButtonOverlay {...mButtonOverlay} />
      </Styled.OverlayContainer>
    </Styled.Wrapper>
  );
};

export * from './MVideoThumbnail.types';
